module.exports = __webpack_public_path__ + "static/media/white.e0920a02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/belts/white.svg
// module id = 72
// module chunks = 0